import { render } from "./CategoryView.vue?vue&type=template&id=4c6333cd"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSS\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__